"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlashPoint = void 0;
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 *
 *
 * @export
 * @param {Object} data response of a compound data request to the PubChem API
 * @param {object} [options={}]
 * @param {object} [options.targetUnits]
 * @returns {ExperimentalData}
 */
function getFlashPoint(data, options = {}) {
    const flashPoint = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Flash Point', {
        parser: (value) => (0, physical_parser_1.parseNumbersUnits)(value, options.temperature),
    });
    return flashPoint;
}
exports.getFlashPoint = getFlashPoint;
//# sourceMappingURL=getFlashPoint.js.map